export const nullToEmptyStringHelper = (item) => Object.entries(item).reduce((acc, [key, value]) => {
    if (key !== 'place_name' && key !== 'debtor_name' && value === null) {
        acc[key] = '0'
    }
    return acc
}, {
    place_name: item.place_name,
    debtor_name: item.debtor_name,
    place_id: item.place_id,
    ...item
})